import { render, staticRenderFns } from "./pressureFan.vue?vue&type=template&id=6037cc2a&scoped=true"
import script from "./pressureFan.vue?vue&type=script&lang=js"
export * from "./pressureFan.vue?vue&type=script&lang=js"
import style0 from "./pressureFan.vue?vue&type=style&index=0&id=6037cc2a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6037cc2a",
  null
  
)

export default component.exports